import React from 'react';
import ErrorFallback from './ErrorFallback';
import FPLError from './FPLError';
import UserNotFoundError from './UserNotFoundError';
import RedirectToMyTeam from './RedirectToMyTeam';
import { datadogRumService } from '@lib/datadogRum';

export enum ErrorType {
  fplFetchError = 'FPL Fetch Error',
  liveRankUserNotFoundError = 'Live Rank User Not Found Error',
  isLiverankError = 'Live Rank Error'
}

type ErrorBoundaryProps = {
  key: string;
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  isFplError: boolean;
  isUserNotFoundError: boolean;
  isLiverankError: boolean;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      isFplError: false,
      isUserNotFoundError: false,
      isLiverankError: false
    };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    if (error.message === ErrorType.fplFetchError) {
      this.setState({ isFplError: true });
    }
    if (error.message === ErrorType.liveRankUserNotFoundError) {
      this.setState({ isUserNotFoundError: true });
    }
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.href;
      if (currentUrl.includes('/my-team/points')) {
        this.setState({ isLiverankError: true });
      }
    }
    // A boundary-caught error is no longer "unhandled", so RUM's automatic
    // collection never sees it; report it explicitly (FFH-1558).
    datadogRumService.addError(error, {
      context: 'react-error-boundary',
      componentStack: errorInfo?.componentStack
    });
    console.info('Hub Error: ', error);
    console.info('Hub Error Info: ', errorInfo);
  }

  render() {
    if (this.state.isFplError) {
      return <FPLError />;
    }
    if (this.state.isUserNotFoundError) {
      return <UserNotFoundError />;
    }
    if (this.state.isLiverankError) {
      return <RedirectToMyTeam />;
    }
    if (this.state.hasError) {
      return <ErrorFallback />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
